/*
  Neroli — article.js
  Builds the table of contents from the article's real headings (no manual
  entry needed from the merchant) and highlights the current section while
  scrolling. Vanilla JS, no dependencies.
*/

document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('[data-article-content]');
  const tocList = document.querySelector('[data-toc-list]');
  const tocWrapper = document.querySelector('[data-article-toc]');
  if (!content || !tocList || !tocWrapper) return;

  const headings = Array.from(content.querySelectorAll('h2, h3'));
  if (headings.length < 2) {
    tocWrapper.hidden = true;
    return;
  }

  const links = [];

  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = `toc-${index}-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    }
    const li = document.createElement('li');
    if (heading.tagName === 'H3') li.style.paddingLeft = '1rem';
    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent;
    li.appendChild(a);
    tocList.appendChild(li);
    links.push({ link: a, heading });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const match = links.find((item) => item.heading === entry.target);
        if (match && entry.isIntersecting) {
          links.forEach((item) => item.link.classList.remove('is-active'));
          match.link.classList.add('is-active');
        }
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );

  headings.forEach((heading) => observer.observe(heading));
});
